import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken, getRefreshToken, setToken, setRefreshToken } from '@/utils/auth'
import Vue from 'vue'
import { Toast } from 'vant'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config
    },
    error => {
        // Do something with request error
        // console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */

        const res = response.data
        console.log(response.data)

        if (res.response_head.retcode !== '0') {
            // Message({
            //   message: res.response_head.retmsg,
            //   type: 'error',
            //   duration: 5 * 1000
            // })
            Toast.fail(res.response_head.retmsg)
            console.log(res.response_head.retmsg, '-------------')
                // 暂时删除

            return Promise.reject(res || 'error')
        } else {
            var infCode = res.response_head.inf_code;
            if (infCode != 'adminlogin') {
                // console.log('-------------63633663636')
                var tokenNew = res.response_head.accesstoken
                var refreshtokenNew = res.response_head.refreshtoken
                console.log("实时的token：" + tokenNew + "实时的tokenrefresh：" + refreshtokenNew)
                console.log("缓存中的token：" + tokenNew + "缓存中的tokenrefresh：" + refreshtokenNew)

                if (tokenNew != getToken()) {
                    setToken(tokenNew)
                }
                if (refreshtokenNew != getRefreshToken()) {
                    setRefreshToken(refreshtokenNew)
                }

            }

            return response.data
        }
    },
    error => {
        console.log('error' + error) // for debug

        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js